import sendPayment from './sendPayment';
import sendPaymentBySms from './sendPaymentBySms';
import cancelPayment from './cancelPayment';
import checkout from './checkout';
import get from './get';
import getByPermalinkWithStatus from './getByPermalinkWithStatus';
import getByPermalink from './getByPermalink';
import messages from './messages';
import checkUsersPaymentAccess from './checkUsersPaymentAccess';
import save from './save';
import createGlobalPayment from './createGlobalPayment';
import chargePaymentByMoto from "./chargePaymentByMoto";
import confirm3dsAuthentication from "./confirm3dsAuthentication";

export default {
  sendPayment,
  sendPaymentBySms,
  cancelPayment,
  checkout,
  get,
  getByPermalinkWithStatus,
  getByPermalink,
  messages,
  checkUsersPaymentAccess,
  save,
  createGlobalPayment,
  chargePaymentByMoto,
  confirm3dsAuthentication,
};



// WEBPACK FOOTER //
// ./src/app/services/payment/index.js